import { Calendar } from "@/components/Calendar";

export default function CalendarPage() {
  // Note: Event details modal is now handled by CallEventModal component
  // which is mounted in App.tsx and responds to ?event= query parameter

  return (
    <div className="min-h-screen bg-background p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold tracking-tight">Calendar</h1>
          <p className="text-muted-foreground mt-2">
            View and manage your scheduled calls and recordings
          </p>
        </div>

        <Calendar />
      </div>
    </div>
  );
}
